// @NOTE: For row and column layout variants view/extend here -> 'libs/web/ui/src/theme/themes/layout/form.js'

import { Fragment } from "react";
import { useUIDSeed } from "react-uid";
import PropTypes from "prop-types";

import { withErrorBoundary } from "../ErrorBoundary";
import getColumns from "./getColumns";
import getField from "./getField";
import getRows from "./getRows";

const DynamicForm = ({ fields }) => {
    const uid = useUIDSeed();

    if (!fields) {
        return null;
    }

    return fields?.map((field) => {
        if (field?.rows && Array.isArray(field?.rows)) {
            return getRows(field?.rows, uid);
        }
        if (field?.columns && Array.isArray(field?.columns)) {
            return getColumns(field?.columns, uid);
        }
        return <Fragment key={uid(field)}>{getField(field)}</Fragment>;
    });
};

DynamicForm.propTypes = {
    fields: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

DynamicForm.defaultProps = {
    fields: undefined,
};

export default withErrorBoundary(DynamicForm);
